import {
  PageSubContainerSkeleton,
  TableSkeleton,
  ToolbarSkeleton,
} from "@project/components/feedback";
import {expedientOffersRouteApi} from "../-route-api";

export function ExpedientOffersPending() {
  const search = expedientOffersRouteApi.useSearch();
  return (
    <PageSubContainerSkeleton>
      <ToolbarSkeleton>
        <ToolbarSkeleton.Button />
        <ToolbarSkeleton.Actions>
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>
      <TableSkeleton columns={6} rows={search.perPage ?? 20} />
    </PageSubContainerSkeleton>
  );
}
